import axios from '../../utils/axios'
import { API_BASE_URL } from '../../constants'

/**
 * Fetches CNV settings for a specific analysis wrapper
 * @param {string|number} analysisWrapperId - The analysis wrapper ID
 * @returns {Promise<object>} The CNV settings data
 */
export const fetchCnvSettings = async (analysisWrapperId, cnvType = null) => {
  try {
    const typeParam = cnvType ? `?type=${cnvType}` : ''
    const { data } = await axios.get(`${API_BASE_URL}/cnv-settings/${analysisWrapperId}${typeParam}`)
    return data
  } catch (error) {
    if (error.response) {
      console.error(`CNV Settings Error: ${error.response.status} - ${error.response.statusText}`)
      throw new Error(error.response.data?.error || `Request failed: ${error.response.status}`)
    } else {
      console.error('CNV Settings Error: No response from server')
      throw new Error('Failed to load CNV settings')
    }
  }
}
